import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Text } from '@bevy/bevy-design-system';

import styles from '../styles.module.less';

const NavbarLink = ({ label, to, name }) => {
  return (
    <NavLink
      key={to}
      className={({ isActive }) =>
        classnames(styles.sidebarLink, { [styles.sidebarLink__active]: isActive })
      }
      to={to}
      aria-label={label}
      data-help-id={`navLink-${name}`}
    >
      <Text variant='body2' size='small'>
        {label}
      </Text>
    </NavLink>
  );
}

NavbarLink.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default NavbarLink;
